export const daMessages = {
    alphanumeric: "Ingen specialtegn, kun bogstaver.",
    required: "Dette felt er påkrævet.",
    remote: "Ret venligst dette felt.",
    email: "Indtast en gyldig email-adresse.",
    url: "Indtast en gyldig URL.",
    date: "Indtast en gyldig dato.",
    dateISO: "Indtast en gyldig dato (ÅÅÅÅ-MM-DD).",
    number: "Indtast et tal.",
    digits: "Indtast kun cifre.",
    equalTo: "Indtast den samme værdi igen.",
    //maxlength: $.validator.format("Indtast højst {0} tegn."),
    //minlength: $.validator.format("Indtast mindst {0} tegn."),
    //rangelength: $.validator.format("Indtast mindst {0} og højst {1} tegn."),
    //range: $.validator.format("Angiv en værdi mellem {0} og {1}."),
    //max: $.validator.format("Angiv en værdi der højst er {0}."),
    //min: $.validator.format("Angiv en værdi der mindst er {0}."),
    //step: $.validator.format("Angiv en værdi gange {0}."),
    creditcard: "Indtast et gyldigt kreditkortnummer.",
    alphanumericRestricted: "Ingen specialtegn, kun bogstaver.",
    reviewrange: "Giv os et point",
    phoneNumber: "Angiv venligst et gyldigt telefonnummer",
    noSpace: "Fjern eventuelle mellemrum",
    passwordCheck: "Kodeordet opfylder ikke kriterierne. Brug mindst ét ​​stort bogstav, ét lille bogstav og ét tal."
} as const;